import { useEffect } from 'react'

import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const useHomeownerAlerts = (deviceId: string) => {
  const {
    homeownerAlerts,
    setHomeownerAlerts,
    areHomeownerAlertsLoaded,
    setAreHomeownerAlertsLoaded
  } = useStoreContext()

  useEffect(() => {
    setAreHomeownerAlertsLoaded(false)
    setHomeownerAlerts(null)

    Api.HomeownerAlerts.get(deviceId)
      .then((res) => {
        setHomeownerAlerts(res)
        setAreHomeownerAlertsLoaded(true)
      })
      .catch(() => {
        setHomeownerAlerts(null)
        setAreHomeownerAlertsLoaded(true)
      })
  }, [deviceId, setHomeownerAlerts, setAreHomeownerAlertsLoaded])

  return { homeownerAlerts, areHomeownerAlertsLoaded }
}

export default useHomeownerAlerts
